const statistics = {
  getSatisticEvents: 'statistics/events/statistics',
  createEvent: 'statistics/events',
  getStatisticInfo: (id: string) => `statistics/events/${id}`,
  updateStatisticEvent: (id: string) => `statistics/events/${id}`,
  removeStatisticEvetn: (id: string) => `statistics/events/${id}`,
}

const emailEndpoints = {
  getAllTemplates: 'template',
  getHystorys: 'email/history',
  removeHysrotys: 'email/history',
  getTemplates: 'template/keys',
  createTemplates: 'template',
  templateInfo: (id: string) => `template/${id}`,
  getTemplateKeys: 'template/keys',
  templateUpdate: (id: string) => `template/${id}`,
  getSmtp: 'smtp',
  editSmtp: 'smtp',
  removeTemplate: 'admin/setting',
  getEmail: 'smtp-user',
  createEmail: 'smtp-user',
  updateEmail: (id: string) => `smtp-user/${id}`,
  deleteEmail: (id: string) => `smtp-user/${id}`,
}

const logsEndpoints = {
  getAllLogs: 'logs/frontend',
  removeFrontendLogs: 'logs/frontend',
  getLogs: 'logs',
  removeLogs: 'logs',
}

const systemEndpoints = {
  getBackendExport: 'system/backend/export',
  backendImport: 'system/backend/import',
}

const adminEndpoints = {
  getUsers: 'admin/users',
  changePassword: 'admin/current/password',
  createUser: 'admin/users',
  getUser: (id: string) => `admin/users/${id}`,
  getUserForm: (id: string) => `admin/user/${id}`,
  editUserAvatar: (id: string) => `admin/users/avatar/${id}`,
  editUserInfo: (id: string) => `admin/users/${id}`,
  editUserPassword: (id: string) => `admin/users/password/${id}`,
  uploadCsv: 'admin/upload-csv', 
}

const feedbackEndpoints = {
  getInfo: (id: string) => `feedback/${id}`,
  edit: (id: string) => `feedback/${id}`,
  getAll: 'feedback',
  remove: (id: string) => `feedback/${id}`,
}

const pricesEndpoints = {
  getInfo: (id: string) => `prices/${id}`,
  edit: (id: string) => `prices/${id}`,
  getAll: 'prices',
  remove: (id: string) => `prices/${id}`,
  add: 'prices',
}

const configurationEndroints = {
  getKeyInfo: (id: string) => `configuration/keys/${id}`,
  keyEdit: (id: string) => `configuration/keys/${id}`,
  getAllKeys: 'configuration/keys/',
  removeKey: (id: string) => `configuration/keys/${id}`,
  createKey: 'configuration/keys',
}

const worksEndpoint = {
  getInfo: (id: string) => `works/${id}`,
  edit: (id: string) => `works/${id}`,
  getPhotos: (id: string) => `works/${id}/photos`,
  getAll: 'works/list',
  add: 'works',
  deletePhoto: 'works/photos/del',
  remove: (id: string) => `works/${id}`,
}
const ordersEndpoints = {
  getInfo: (id: string) => `orders/${id}`,
  getAll: 'orders',
  remove: (id: string) => `orders/${id}`,
}
const reviewsEndpoint = {
  getInfo: (id: string) => `reviews/${id}`,
  publishReview: (id: string) => `reviews/publish/${id}`,
  add: 'reviews',
  edit: (id: string) => `reviews/${id}`,
  getAll: 'reviews',
  remove: (id: string) => `reviews/${id}`,
}

const servicesEndpoint = {
  getInfo: (id: string) => `services/${id}`,
  edit: (id: string) => `services/${id}`,
  getAll: 'services/list',
  getCategories: 'categories',
  add: 'services',
  deletePhoto: 'services/photos/del',
  remove: (id: string) => `services/${id}`,
}

const servicesSchemaEndpoint = {
  edit: 'services-schema',
  getInfo: 'services-schema',
  remove: (id: string) => `services-schema/${id}`,
}
const userEndpoints = {
  getCurrent: 'users/current',
  changeAvatar: 'users/current/avatar',
  changeInfo: 'users/current',
  getRoles: 'roles',
  editUser: 'users/current',
  editPassword: 'users/current/password',
  editUserAvatar: 'users/avatar',
  changePassword: 'users/current/password',
}

const seoEndpoints = {
  getInfo: (id: string) => `seo/${id}`,
  edit: (id: string) => `seo/${id}`,
  getAll: 'seo/list',
  add: 'seo',
  remove: (id: string) => `seo/${id}`,
}

const metricsEndpoint = {
  getInfo: (id: string) => `metrics/${id}`,
  getListWorksAndServices: 'metrics/list-works-and-services',
  edit: (id: string) => `metrics/${id}`,
  getAll: 'metrics',
  add: 'metrics',
  remove: (id: string) => `metrics/${id}`,
}

const authEndpoints = {
  login: 'login',
  register: 'requests',
  recoveryPassword: 'change/password',
  recoveryChangePassword: (key: string) => `change/password/recovery/${key}`,
}
//-------------Template-------------

const surveyEndpoints = {
  create: 'surveys',
  getAll: 'surveys',
  getInfo: (id: string) => `surveys/${id}`,
  remove: (id: string) => `surveys/${id}`,
}

const demoEndpoints = {
  create: 'demos',
  getAll: 'demos',
  getInfo: (id: string) => `demos/${id}`,
  remove: (id: string) => `demos/${id}`,
}

const orderEndpoints = {
  create: 'orders',
  getAll: 'orders',
  getInfo: (id: string) => `orders/${id}`,
  remove: (id: string) => `orders/${id}`,
}

export const ENDPOINT_LIST = {
  adminEndpoints,
  worksEndpoint,
  metricsEndpoint,
  servicesEndpoint,
  servicesSchemaEndpoint,
  seoEndpoints,
  userEndpoints,
  statistics,
  logsEndpoints,
  configurationEndroints,
  feedbackEndpoints,
  systemEndpoints,
  emailEndpoints,
  pricesEndpoints,
  authEndpoints,
  ordersEndpoints,
  reviewsEndpoint,
  surveyEndpoints,
  demoEndpoints,
  orderEndpoints,
}
